import { User, UserManager, WebStorageStateStore } from "oidc-client-ts";
import { getCognitoAuthConfig } from "@/frontend/config";

let redirectListeners: ((hash: string) => void)[] = [];

export const addRedirectListener = (
    listener: (hash: string) => void
): (() => void) => {
    redirectListeners.push(listener);
    return () => {
        redirectListeners = redirectListeners.filter(l => l !== listener);
    };
};

export const onSigninCallback = () => {
    // extract redirect hash from url
    let hash = "";
    const urlParams = new URLSearchParams(window.location.search);
    const state = urlParams.get("state");
    if (state) {
        const bits = state.split(";REDIRECT_HASH=#");
        if (bits[1]) {
            hash = bits[1];
        }
    }

    // remove callback state from url
    window.history.replaceState({}, document.title, window.location.pathname);

    // notify listeners
    if (hash) {
        redirectListeners.forEach(l => {
            l(hash);
        });
    }
};

export const userManager = new UserManager({
    ...getCognitoAuthConfig(),
    userStore: new WebStorageStateStore({ store: localStorage }),
    stateStore: new WebStorageStateStore({ store: sessionStorage }),
    revokeTokenTypes: ["refresh_token"]
});

export function getOidcUser() {
    const settings = getCognitoAuthConfig();

    const oidcStorage = localStorage.getItem(
        `oidc.user:${settings.authority}:${settings.client_id}`
    );

    if (!oidcStorage) {
        return null;
    }

    const user = User.fromStorageString(oidcStorage);
    return user;
}

let refreshTokenPromise: Promise<void> | undefined;

/// don't make more calls to signinSilent than is necessary
export async function refreshToken() {
    try {
        if (refreshTokenPromise) {
            await refreshTokenPromise;
            return;
        }
        refreshTokenPromise = (async () => {
            await userManager.signinSilent();
            refreshTokenPromise = undefined;
        })();
        await refreshTokenPromise;
    } catch (error) {
        // if an error occurs while refreshing the token, we don't want to bubble it up to the caller
        // instead let the calling code continue and raise errors later if applicable (eg returning 401 from api call)
        // eslint-disable-next-line no-console
        console.error("Error refreshing token", error);
    }
}
